/** Displays the toolbar for formatting text, used by TextEditor */
import React from "react";
import { Grid } from "@mui/material";

import { EditorToolbarProps } from "./types";

/**
 * The toolbar component is currently preloaded with all the buttons needed and will change size dynamically
 * @param {string} className Used for CSS
 * @returns {jsx} Toolbar with all the formatting buttons
 */
const EditorToolbar = ({
    className,
    buttons,
    popover,
    align,
}: EditorToolbarProps): any => {
    let buttonTest = new Array(buttons.length);
    for (let i = 0; i < buttons.length; ++i) {
        buttonTest[i] = buttons[i];
    }

    return (
        <Grid
            container
            key={className}
            className={className}
            justifyContent={align}
            alignItems="center"
            sx={{ border: "1px solid #DFE7EE", borderWidth: "0 0 1px 0" }}
        >
            {buttons.map((e, i) => {
                return (
                    <React.Fragment key={i}>
                        {buttonTest.shift()}
                    </React.Fragment>
                );
            })}
            {popover !== undefined ? (
                <Grid container item spacing={0} justifyContent="space-evenly">
                    {popover}
                </Grid>
            ) : (
                ""
            )}
        </Grid>
    );
};

export default EditorToolbar;
